<template>
  <v-card class="mx-0">
    <v-card-title>
      <h3 class="primary_dark--text text-center">Simula tu crédito</h3>
    </v-card-title>
    <v-card-text>
      <v-layout px-3 row wrap>
        <v-flex v-if="selector" mx-3 xs12>
          <v-select
            v-model="creditTypeSelected"
            outlined
            label="Selecciona el tipo de crédito"
            :items="creditTypes"
          ></v-select>
        </v-flex>
        <v-flex mx-3 xs12>
          <h3 class="mb-3">Monto</h3>
          <h2 class="primary--text mb-3">{{credit | currency}}</h2>
          <v-slider
            v-model="credit"
            color="primary"
            track-color="primary"
            always-dirty
            :min="min"
            :max="max"
          >
            <template v-slot:prepend>
              <v-icon color="primary" @click="credit--">mdi-minus</v-icon>
            </template>
            <template v-slot:append>
              <v-icon color="primary" @click="credit++">mdi-plus</v-icon>
            </template>
          </v-slider>
        </v-flex>
        <v-flex mx-3 xs12>
          <h3 class="mb-3">Plazo</h3>
          <h2 class="primary--text mb-3">{{time != 1 ? time + ' años' : time + ' año'}}</h2>
          <v-slider
            v-model="time"
            color="primary"
            track-color="primary"
            always-dirty
            :min="1"
            :max="10"
          >
            <template v-slot:prepend>
              <v-icon color="primary" @click="time--">mdi-minus</v-icon>
            </template>
            <template v-slot:append>
              <v-icon color="primary" @click="time++">mdi-plus</v-icon>
            </template>
          </v-slider>
        </v-flex>
        <v-flex mx-3 xs12>
          <h2 class="primary_dark--text">Pago mensual aproximado:</h2>
        </v-flex>
        <v-flex mx-3 mt-2 xs12>
          <h2 class="primary_dark--text">{{monthlyPayment | currency}}</h2>
        </v-flex>
        <v-flex mx-3 mt-6 mb-2 xs12>
          <v-btn color="primary" large class="boldFont">Solicitar mi crédito</v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["selector", "creditype"],
  mounted() {
    this.creditTypeSelected = !this.selector
      ? this.creditype
      : "Crédito PYME HIPOTECARIO";
  },
  data() {
    return {
      creditTypeSelected: "Crédito PYME HIPOTECARIO",
      credit: 5000,
      max: 1000000,
      min: 5000,
      time: 1
    };
  },
  watch: {
    creditTypeSelected(val) {
      this.$store.dispatch("simulatorPyme/setCreditType", val);
      switch (val) {
        case "Crédito PYME HIPOTECARIO":
          this.min = 5100;
          this.max = 1000000;
          break;
        case "Crédito PYME PRENDARIO":
          this.min = 5100;
          this.max = 1000000;
          break;
        case "Crédito CAPITERRENO":
          this.min = 5100;
          this.max = 1000000;
          break;
      }
      this.credit = this.min;
    },
    time(val) {
      let params = {
        time: val,
        credit: this.credit
      };
      this.$store.dispatch("simulatorPyme/getMonthlyPayment", params);
    },
    credit(val) {
      let params = {
        time: this.time,
        credit: val
      };
      this.$store.dispatch("simulatorPyme/getMonthlyPayment", params);
    }
  },
  computed: {
    ...mapState({
      creditTypes: state => state.simulatorPyme.creditTypes,
      monthlyPayment: state => state.simulatorPyme.monthlyPayment
    })
  }
};
</script>
<style scoped>
.boldFont{
      font-weight: bolder !important;
}
</style>